import type { DiagramDocument } from '@ukrop-nm/shared';
import { createEmptyDiagram, normalizeNetworkLifecycle } from '@ukrop-nm/shared';
import officeEtalon from '../../../../samples/diagram-office-3floor-etalon.json';
import { accountStorageKey } from '../auth/accountScope';
import { BUILTIN_SITE_IDS, listCustomSites } from './siteIndex';

export function countDevicesInDiagram(doc: DiagramDocument): number {
  return doc.nodes.filter((n) => n.type !== 'zone').length;
}

function loadStoredDiagram(siteId: string): DiagramDocument | null {
  try {
    const raw = localStorage.getItem(accountStorageKey(`diagram.${siteId}`));
    if (!raw) return null;
    const doc = JSON.parse(raw) as DiagramDocument;
    doc.lifecycle = normalizeNetworkLifecycle(doc.lifecycle);
    return doc;
  } catch {
    return null;
  }
}

function diagramForSite(siteId: string): DiagramDocument | null {
  const stored = loadStoredDiagram(siteId);
  if (stored) return stored;
  if (siteId === 'SITE-OFFICE-3F') {
    const doc = structuredClone(officeEtalon) as DiagramDocument;
    doc.siteId = 'SITE-OFFICE-3F';
    doc.lifecycle = normalizeNetworkLifecycle(doc.lifecycle) || 'draft';
    return doc;
  }
  const site = listCustomSites().find((s) => s.id === siteId);
  if (site) {
    return createEmptyDiagram(siteId, site.title, site.lifecycle);
  }
  return null;
}

/** Sum non-zone nodes across etalon and all custom site diagrams in this browser/account. */
export function countAllDiagramDevices(): number {
  const siteIds = new Set<string>([...BUILTIN_SITE_IDS, ...listCustomSites().map((s) => s.id)]);
  let total = 0;
  for (const siteId of siteIds) {
    const doc = diagramForSite(siteId);
    if (doc) total += countDevicesInDiagram(doc);
  }
  return total;
}
